"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeFormats = void 0;
exports.TimeFormats = {
    dateTimeLocal: "YYYY-MM-DD[T]HH:mm:ss",
    dateTimeUTC: "YYYYMMDD[T]HHmmss[Z]",
    allDay: "YYYYMMDD",
};
//# sourceMappingURL=utils.js.map